import { useEffect } from "react"
import './InnovationWorkshop.less'
import { orderLoadImg } from '@/utils/tool'

const InnovationWorkshop = () => {

  const imgList = [
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/innovationWorkshop/list-01.png',
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/innovationWorkshop/list-02.png',
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/innovationWorkshop/list-03.png',
    'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/innovationWorkshop/list-04.png',
  ]

  useEffect(() => {
    orderLoadImg('pg-innovationWorkshop', imgList)
  }, [])
  return (
    <div className="pg-innovationWorkshop"></div>
  )
}

export default InnovationWorkshop